import { Marker } from 'mapbox-gl';
import { StandPriorityColor } from '../Stand';
import '../marker.scss';
import polylabel from 'polylabel';
import { reaction } from 'mobx';
import * as turf from '@turf/turf';
export default class StandMarker {
    constructor(props) {
        this.addToMap = (map) => {
            if (this._map)
                return;
            this._map = map;
            if (this._marker) {
                this._marker.addTo(map);
            }
            this._priorityReactionDisposer = reaction(() => this._stand.priority(), (priority) => {
                const priorityClassName = StandPriorityColor[priority];
                const elementEmpty = this._elementEmpty;
                elementEmpty.className = '';
                elementEmpty.classList.add(priorityClassName);
                elementEmpty.classList.add('empty');
            }, { fireImmediately: true });
        };
        this.removeFromMap = () => {
            var _a, _b;
            if (!this._map)
                return;
            (_a = this._marker) === null || _a === void 0 ? void 0 : _a.remove();
            this._map = undefined;
            (_b = this._priorityReactionDisposer) === null || _b === void 0 ? void 0 : _b.call(this);
        };
        this.findPolylabel = (feature) => {
            let output = [];
            const precisionValue = 0.0005;
            if (feature.geoJSON.geometry.type === "Polygon") {
                output = polylabel(feature.geoJSON.geometry.coordinates, precisionValue);
            }
            else if (feature.geoJSON.geometry.type === "MultiPolygon") {
                let maxArea = 0, maxPolygon = [];
                for (let i = 0, l = feature.geoJSON.geometry.coordinates.length; i < l; i++) {
                    const p = feature.geoJSON.geometry.coordinates[i];
                    const area = turf.area({ type: "Polygon", coordinates: p });
                    if (area > maxArea) {
                        maxPolygon = p;
                        maxArea = area;
                    }
                }
                output = polylabel(maxPolygon, precisionValue);
            }
            return output;
        };
        const { stand } = props;
        this._stand = stand;
        const elementRoot = document.createElement('div');
        elementRoot.className = 'marker';
        this._elementRoot = elementRoot;
        this._elementEmpty = document.createElement('div');
        const tooltip = document.createElement('span');
        tooltip.setAttribute('tooltip', stand.extensionLabel);
        this._elementEmpty.appendChild(tooltip);
        const position = this.findPolylabel(stand);
        if (position) {
            this._marker = new Marker(elementRoot).setLngLat(position);
        }
        this._elementRoot.appendChild(this._elementEmpty);
    }
}
